import supabase from '../supabase/supabase';

/**
 * Cria um pagamento para o usuário logado
 */
export const createPayment = async (amount, credits, method) => {
  const { data, error } = await supabase.rpc('secure_create_asaas_payment', {
    p_amount: amount,
    p_credits: credits,
    p_method: method
  });

  if (error) throw new Error(error.message);
  if (data?.error) throw new Error(data.error);

  return {
    success: true,
    invoiceUrl: data.invoiceUrl,
    id: data.id
  };
};

/**
 * Cria um pagamento administrativo para um usuário específico
 */
export const adminCreatePayment = async (userId, amount, credits, description) => {
  const { data, error } = await supabase.rpc('secure_admin_create_asaas_payment', {
    p_target_user_id: userId,
    p_amount: amount,
    p_credits: credits,
    p_description: description
  });

  if (error) throw new Error(error.message);
  if (data?.error) throw new Error(data.error);

  return data;
};

/**
 * Inicializa ou obtém o cliente Asaas do usuário logado
 */
export const getOrCreateCustomer = async () => {
  const { data, error } = await supabase.rpc('secure_get_or_create_asaas_customer');
  if (error) throw new Error(error.message);
  if (data?.error) throw new Error(data.error);
  return data.customer_id;
};